// Operaciones que emiten o renuevan la sesión del empleado (refresh,
// issueWithoutPin) en UNA sola vuelo a la vez.
//
// Al recargar podían lanzarse a la vez la revalidación del arranque, el
// auto-refresh del interceptor, el keep-alive (focus/visibilidad) y la
// asignación del dispositivo. Cada emisión rotaba el token del dispositivo;
// las peticiones en vuelo con el anterior recibían 401, se borraba la sesión
// y se re-emitía otra vez: tormenta de 401 y bucle de issueWithoutPin.
//
// Además se recuerda qué empleados necesitan PIN (issueWithoutPin respondió
// PIN_REQUIRED) para no volver a pedirlo en cada comprobación.

let current = null; // { key, promise }
const pinRequired = new Set();

/**
 * Ejecuta `fn` si no hay otra operación de sesión en curso. Si la hay con la
 * misma clave, devuelve su promesa; si es otra, espera a que acabe y luego
 * ejecuta (las operaciones nunca se solapan).
 */
export function runSessionOp(key, fn) {
  if (current && current.key === key) return current.promise;
  const previous = current ? current.promise.catch(() => {}) : Promise.resolve();
  const promise = previous.then(() => fn());
  const entry = { key, promise };
  current = entry;
  const done = () => { if (current === entry) current = null; };
  promise.then(done, done);
  return promise;
}

/** Promesa de la operación de sesión en curso (o null). */
export function sessionOpInFlight() {
  return current ? current.promise.catch(() => {}) : null;
}

export function markPinRequired(employeeId) {
  const id = Number(employeeId) || 0;
  if (id > 0) pinRequired.add(id);
}

export function isPinRequired(employeeId) {
  return pinRequired.has(Number(employeeId) || 0);
}

/** Tras identificarse con PIN ya no hace falta recordarlo. */
export function clearPinRequired(employeeId) {
  pinRequired.delete(Number(employeeId) || 0);
}

export function resetSessionOpsForTests() {
  current = null;
  pinRequired.clear();
}
